import {
  createSelector,
  createFeatureSelector,
} from '@ngrx/store';
import * as fromMeasure from './measure.reducer';


// get the selectors
const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = fromMeasure.adapter.getSelectors();

export const selectMeasureState = createFeatureSelector<fromMeasure.State>('measures');

export const selectMeasureIds = createSelector(
  selectMeasureState,
  selectIds
);
export const selectMeasureEntities = createSelector(
  selectMeasureState,
  selectEntities
);
export const selectAllMeasures = createSelector(
  selectMeasureState,
  selectAll
);
export const selectMeasureTotal = createSelector(
  selectMeasureState,
  selectTotal
);

export const selectCurrentMeasureId = createSelector(
  selectMeasureState,
  fromMeasure.getSelectedMeasureId
);

export const selectCurrentMeasure = createSelector(
  selectMeasureEntities,
  selectCurrentMeasureId,
  (entities, id) => (id) ? entities[id] : null
);

export const selectMeasureById = (id: string) => createSelector(
  selectMeasureEntities,
  (entities) => {
    return entities[id];
  }
);

export const selectMeasureShowById = (id: string) =>
  createSelector(
    selectMeasureEntities,
    (entities): boolean => !!entities[id]?.show
  );
